<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        <h4 class="ts-text-sm">
          {{ $t('classTeaching.chooseStatus') }}
        </h4>
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <form>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{
                $t('classTeaching.studentStatus')
              }}</label>
              <div>
                <select class="form-control" v-model="status_id">
                  <option value="">{{ $t('clasSteaching.all') }}</option>
                  <option :value="1">{{ $t('clasSteaching.active') }}</option>
                  <option :value="2">{{
                    $t('clasSteaching.Droped out')
                  }}</option>
                  <option :value="3">{{ $t('clasSteaching.Suspend') }}</option>
                  <option :value="4">{{
                    $t('clasSteaching.Terminated')
                  }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="row ts-mt-6">
          <div class="col-sm-12 col-lg-12 col-md-12 text-right">
            <ts-button class="btn-sm" @click.prevent="$emit('close')">{{
              $t('cancel')
            }}</ts-button>
            <ts-button
              color="primary"
              class="ml-2 btn-sm"
              :waiting="exporting"
              @click.prevent="excel"
              >{{ $t('export') }}</ts-button
            >
          </div>
        </div>
      </form>
    </ts-card-wrapper>
  </div>
</template>

<script>
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'
export default {
  props: ['record'],
  name: 'excelExport',
  data() {
    return {
      status_id: 1,
      exporting: false
    }
  },
  methods: {
    excel() {
      this.exporting = true

      this.$store
        .dispatch(
          'classTeaching/excel',
          Object.assign({}, this.record, { status_id: this.status_id })
        )
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
        })
        .finally(() => (this.exporting = false))
    }
  }
}
</script>
